export const RISK_LABELS = {
  ok: 'Без риска',
  low: 'Низкий',
  medium: 'Средний',
  high: 'Высокий',
  very_high: 'Очень высокий',
};

export function riskScoreStyle(score, riskLevel) {
  if (riskLevel === 'ok') return 'border-emerald-400/30 bg-emerald-400/10 text-emerald-700 dark:text-emerald-200';
  if (score >= 75) return 'border-red-400/30 bg-red-400/10 text-red-700 dark:text-red-200';
  if (score >= 50) return 'border-orange-400/30 bg-orange-400/10 text-orange-700 dark:text-orange-200';
  if (score >= 25) return 'border-amber-400/30 bg-amber-400/10 text-amber-800 dark:text-amber-200';
  return 'border-sky-400/30 bg-sky-400/10 text-sky-700 dark:text-sky-200';
}

export function riskBarStyle(score, riskLevel) {
  if (riskLevel === 'ok') return 'bg-emerald-400';
  if (score >= 75) return 'bg-red-400';
  if (score >= 50) return 'bg-orange-400';
  if (score >= 25) return 'bg-amber-400';
  return 'bg-sky-400';
}
